import React, { MouseEvent } from 'react';
import IconX from 'components/IconX';

interface CloseButtonProps {
  onClose: (event: MouseEvent) => unknown;
  fixed?: boolean;
}

type Props = React.FC<React.HTMLProps<HTMLDivElement> & CloseButtonProps>;

const CloseButton: Props = ({ className, onClose, fixed = false, ...props }) => {
  return (
    <div
      {...props}
      onClick={onClose}
      tabIndex={0}
      role="button"
      className={`${
        fixed ? `fixed top-16 right-16 text-right` : ``
      } z-50 inline-flex h-[40px] w-[40px] cursor-pointer items-center justify-center bg-white transition-all ease-ease-hover hover:bg-gray-light ${
        className ? className : ''
      }`}
    >
      <IconX />
    </div>
  );
};

CloseButton.displayName = 'CloseButton';

export default CloseButton;
